import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import theBG1 from "../../../assets/images/front2.png";
import IconButton from "@material-ui/core/IconButton";
import Facebook from "@material-ui/icons/Facebook";
// import YoutubeIcon from "@material-ui/icons/YouTube";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import AOS from "aos";
import "aos/dist/aos.css";

const useStyles = makeStyles((theme) => ({
  bg: {
    height: "100vh",
    width: "100%",
    backgroundSize: "cover",
    color: "white",
    lineHeight: "2",
  },
  breathAnimation: {
    background: "linear-gradient(270deg, #a59890, #cac2bd)",
    backgroundSize: "400% 400%",
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    animation: "breath 3s ease infinite",
    width: "50rem",
    maxWidth: "50rem",
  },
  styleText: {
    textTransform: "uppercase",
    fontWeight: 300,
  },
}));
const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});
export default function Contact() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Card className={classes.bg}>
      <CardMedia
        component="img"
        alt="Contemplative Reptile"
        image={theBG1}
        style={{ width: "100%", height: "100%" }}
      />
      <Grid
        container
        style={{
          position: "fixed",
          zIndex: 1,
          top: 0,
          height: "100vh",
          display: "flex",
          justifyContent: "flex-end",
          overflow: "auto",
        }}
      >
        <Grid item className={classes.breathAnimation}>
          <Grid
            item
            style={{
              marginTop: "10rem",
              paddingLeft: "5rem",
            }}
          >
            <Typography
              variant="h3"
              style={{ fontWeight: 300 }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              Liên hệ
            </Typography>
            <br />
            <div
              style={{ paddingLeft: "2rem" }}
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <Typography
                variant="h5"
                gutterBottom
                className={classes.styleText}
              >
                Mạng xã hội
              </Typography>
              <IconButton
                href="https://www.facebook.com/bunbapboonhu"
                target="_blank"
                rel="noreferrer"
              >
                <Facebook
                  fontSize="large"
                  style={{
                    color: "#996f32",
                  }}
                />
              </IconButton>
              {/* <IconButton>
                <YoutubeIcon
                  fontSize="large"
                  style={{
                    color: "#996f32",
                  }}
                />
              </IconButton> */}
              <Typography
                variant="h5"
                gutterBottom
                className={classes.styleText}
              >
                Thông tin
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  maxWidth: "17rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: " flex-start",
                  }}
                >
                  <Phone />
                  <Email />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: " flex-end",
                  }}
                >
                  <Typography variant="body1">0933913903</Typography>
                  <Typography variant="body1">
                    bunbapboonhu134@gmail.com
                  </Typography>
                </div>
              </div>
              <br />
              <Typography
                variant="h5"
                gutterBottom
                className={classes.styleText}
              >
                Giờ làm việc
              </Typography>
              <Typography variant="body1">
                Từ thứ 2 tới CN từ 6:30 am tới 12:00pm
              </Typography>
              <Typography variant="body1">Làm luôn lễ Tết!</Typography>
              <br />
              <ThemeProvider theme={serifFont}>
                <Typography
                  variant="body1"
                  style={{ textTransform: "uppercase" }}
                >
                  Bún bò O Như
                </Typography>
              </ThemeProvider>
              <Typography variant="body1">134 Cao Lỗ, P.4 Q.8</Typography>
              <Typography variant="body1">Hồ Chí Minh, Việt Nam</Typography>
              <a
                href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
                target="_blank"
                rel="noreferrer"
                style={{ color: "white", textTransform: "uppercase" }}
              >
                Google Map
              </a>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}
